/**
 * Kaskadowe menu Biżuterii (desktop) - przełączanie podkategorii w lewej belce.
 *
 * Markup: layouts/partials/header/components/desktop-navigation/jewellery-cascade.twig
 * Najechanie / fokus / klik na .js-cascade-tab aktywuje odpowiedni .js-cascade-pane
 * (parowanie po data-cascade-key). Obsługa klawiatury: strzałki góra/dół, Home/End.
 */
export const jewelleryCascade = () => {
    const roots = [...document.querySelectorAll('.jewellery-cascade')];
    if (!roots.length) return;

    roots.forEach((root) => {
        const tabs = [...root.querySelectorAll('.js-cascade-tab')];
        const panes = [...root.querySelectorAll('.js-cascade-pane')];
        if (!tabs.length || !panes.length) return;

        const activate = (key, focusTab = false) => {
            tabs.forEach((tab) => {
                const isActive = tab.dataset.cascadeKey === key;
                tab.classList.toggle('is-active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.setAttribute('tabindex', isActive ? '0' : '-1');
                if (isActive && focusTab) tab.focus();
            });
            panes.forEach((pane) => {
                const isActive = pane.dataset.cascadeKey === key;
                pane.classList.toggle('is-active', isActive);
                pane.hidden = !isActive;
            });
        };

        tabs.forEach((tab, i) => {
            tab.addEventListener('mouseenter', () => activate(tab.dataset.cascadeKey));
            tab.addEventListener('focus', () => activate(tab.dataset.cascadeKey));
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                activate(tab.dataset.cascadeKey, true);
            });

            tab.addEventListener('keydown', (e) => {
                const { key } = e;
                let nextIndex = null;

                if (key === 'ArrowDown') nextIndex = (i + 1) % tabs.length;
                else if (key === 'ArrowUp') nextIndex = (i - 1 + tabs.length) % tabs.length;
                else if (key === 'Home') nextIndex = 0;
                else if (key === 'End') nextIndex = tabs.length - 1;

                if (nextIndex !== null) {
                    e.preventDefault();
                    activate(tabs[nextIndex].dataset.cascadeKey, true);
                }
            });
        });
    });
};
